import React, { useEffect, useState } from 'react';

// Local Resources
import { ANALYSIS_TYPE, MeasurementStatetoHTML, AnalysisResultToIconState } from '../enums';

// MaterialUI
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';

// Tippy.JS Resources
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/animations/shift-away.css';

// Default image size parameters
const defaultWidth = 64;
const defaultHeight = 70;

function BuildPopover(systemState) {

	const voltage = MeasurementStatetoHTML('System', systemState.voltage, ANALYSIS_TYPE.VOLTAGE, 1);
	const current = MeasurementStatetoHTML('System', systemState.current, ANALYSIS_TYPE.CURRENT);
	// const ambitemp = MeasurementStatetoHTML('Ambient', systemState.ambient_temp, ANALYSIS_TYPE.TEMPERATURE);

	return (
		<span
			style={{
				fontFamily: 'Saira, sans-serif',
				fontWeight: '600'
			}}
		>
			<p><b>System</b></p>
			{voltage}<br />
			{current}<br />
			{/* {ambitemp}<br /> */}
		</span>
	);
}

export default function SystemIcon(props) {

	const {systemState, onClick, scale = 1.0} = props;

	const sysState = Math.max(0, systemState.voltage.result, systemState.current.result);
	const iconState = AnalysisResultToIconState(sysState);
	const imgPath = `/images/batterymap_icons/ups_${iconState}.svg`;

	const popover = BuildPopover(systemState)

	return (
		<Tippy
			content={popover}
			placement="bottom"
			animation="shift-away"
		>
			<Button
				sx={{
					padding: 0,
					margin: '3px',
				}}
				onClick={() => onClick()}
			>
				<Box
					border='solid'
					borderRadius={0.75}
					borderColor='#FFFFFF11'
					bgcolor='#FFFFFF22'
					padding='3px'
					margin='1px'
					sx={{
						borderWidth: '1px',
						'&:hover': {
							color: '#FFFFFF',
							backgroundColor: '#FFFFFF44',
						},
					}}
				>
					<img src={imgPath} width={defaultWidth * scale} height={defaultHeight * scale} alt={`system icon`} />
					<Typography
						fontFamily='Helvetica Neue LT Std Roman, sans-serif'
						color='#FFFFFF'
						align='center'
						sx={{ fontSize: `calc(1rem * ${scale})` }}
					>
						Charger
					</Typography>
				</Box>
			</Button>
		</Tippy>
	);
}